import React from 'react';
import {Modal, Button} from 'semantic-ui-react';
import {dateFormatReservation} from '../../../common/constants/datesFormat';

const ModalComponent = ({open, onClose, dateSelect, calendarUpdateDaTe}) => {
  const parseDate = dateSelect.format(dateFormatReservation);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size='small'
    >
      <Modal.Header>Fecha seleccionada {parseDate}</Modal.Header>
      <Modal.Content image>
        <Modal.Description>
          Desea cambiar el estado del día?
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={onClose}>
              Cerrar
        </Button>
        <Button
          color="green"
          content="Aceptar"
          onClick={() => calendarUpdateDaTe(parseDate)}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalComponent;
